export const delawareCountiesList = [
    'Kent',
    'New Castle',
    'Sussex',
    ]